export default {
  name: 'dashify:CustomLink',
  title: 'Link',
  owner: 'System',
  solution: '',
  tags: ['html', 'link'],
  createdAt: 'May 30, 2023, 10:14 AM',
  updatedAt: 'May 31, 2023, 11:14 AM',
  spec: {
    path: ['a', 'b', 'c'],
    bar: 'b',
    now: '${ $now() }',
    random: '${ $random() }',
    href: '${ "/" & $join(path,"/") & "?bar=" & bar & "&now=" & now & "&random=" & random }',
    view: [
      ['a', { '.': 'link', href: '/${ href }' }, 'Go To URL'],
      ['p', { '.': 'p-2' }, "/${ 'URL:  ' & href }"],
    ],
  },
};
